export default __webpack_public_path__ + "static/media/brandballoons-background-image.f8baba5b.png";